module.exports = __webpack_public_path__ + "img/taobao.302afb20.jpg";